export enum ClientStatusCode {
  NEW = "client_new",
  ACTIVE = "client_active",
  INACTIVE = "client_inactive"
}
